import { Box, Button, Typography, useTheme } from "@mui/material";
import { GetChannels } from "contexts/ChannelsContext";
import { GetCInfo } from "contexts/CompanyContext";
import { GetData } from "contexts/DataContext";
import { saveMap } from "data/functions";
import Logo from "data/images/logo.svg";
import SbpLogoWithText from "data/images/sbp2.svg";
import SbpLogoWhite from "data/images/sbp_white.svg";
import { QRCodeBlock } from "pages/code/Main";
import React from "react";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Mousewheel, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

export function MainBody(props) {
  const { cInfo } = GetCInfo();
  const { channels, statuses } = GetChannels();
  const { dataObj } = GetData();
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <Swiper
        autoplay={{
          delay: Number(dataObj?.sliderDelay || "15") * 1000,
          disableOnInteraction: false,
        }}
        modules={[Navigation, Autoplay, Mousewheel]}
        mousewheel={{
          releaseOnEdges: true,
        }}
        pagination={{
          clickable: true,
        }}
        slidesPerView={1}
        spaceBetween={12}
        style={{
          alignItems: "center",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          height:
            dataObj?.payType === "self-service" && !dataObj?.disablePayButton
              ? undefined
              : "100%",
          justifyContent: "center",
          // minHeight: "400px",
          padding: "24px 0",
          width: "100%",
        }}
      >
        {saveMap(channels, "MainBody").map((item, index) => {
          let status = statuses ? statuses[item?.id] : true;
          if (status === false) return "";
          return (
            <SwiperSlide
              key={index}
              style={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  textAlign: "center",
                  transform: dataObj?.zoom
                    ? `scale(${dataObj?.zoom / 100})`
                    : undefined,
                  width: "80%",
                }}
              >
                <Typography
                  sx={{
                    overflowWrap: "break-word",
                    padding: "0.4rem",
                    typography: {
                      lg: "h5",
                      md: "h6",
                      sm: "body1",
                      xl: "h4",
                      xs: "body2",
                    },
                    userSelect: "none",
                    whiteSpace: "pre-line",
                  }}
                  variant="h4"
                >
                  {item?.header}
                </Typography>
                {item?.id !== "Default" ? (
                  <QRCodeBlock
                    color1={item?.color1}
                    color2={item?.color2}
                    image={
                      item?.logo
                        ? item?.logo
                        : cInfo?.style?.logoMain?.url ||
                          cInfo?.style?.logoSecond?.url ||
                          Logo
                    }
                    url={item?.url}
                  />
                ) : (
                  <img
                    alt="SBP"
                    src={
                      theme?.palette?.mode === "light"
                        ? SbpLogoWithText
                        : SbpLogoWhite
                    }
                    style={{
                      height: "auto",
                      maxHeight: "50vh",
                      maxWidth: "80%",
                      padding: "0.4rem",
                    }}
                  />
                )}
                <Typography
                  sx={{
                    overflowWrap: "break-word",
                    padding: "0.4rem",
                    typography: {
                      lg: "h5",
                      md: "h6",
                      sm: "body1",
                      xl: "h4",
                      xs: "body1",
                    },
                    userSelect: "none",
                    whiteSpace: "pre-line",
                  }}
                  variant="h4"
                >
                  {item?.footer}
                </Typography>
              </Box>
            </SwiperSlide>
          );
        })}
      </Swiper>
      {dataObj?.payType === "self-service" && !dataObj?.disablePayButton && (
        <Box
          sx={{
            // position: "absolute",
            maxWidth: "820px",
            // bottom: 0,
            padding: "24px",
            width: "100%",
            zIndex: 2,
          }}
        >
          <Button
            fullWidth
            onClick={() => navigate("orders")}
            sx={{ minHeight: { md: "100px", xs: "50" } }}
            variant="outlined"
          >
            Оплатить документ
          </Button>
        </Box>
      )}
    </React.Fragment>
  );
}
